import angular from 'angular'
import routers from './routers'
import {
    reportTemplateSetting
} from 'redevConfig'


const add = (reportTemplateSetting && reportTemplateSetting.add) || ''
const edit = (reportTemplateSetting && reportTemplateSetting.edit) || ''
const list = (reportTemplateSetting && reportTemplateSetting.list) || ''
const preview = (reportTemplateSetting && reportTemplateSetting.preview) || ''

const reportTemplateSettingCtrl = list ? require(`redevelopment/system/reportTemplateSetting/${list.controllerName}`) : require('./reportTemplateSettingCtrl')
const reportTemplateAddCtrl = add ? require(`redevelopment/system/reportTemplateSetting/${add.controllerName}`) : require('./reportTemplateAddCtrl')
const reportTemplateEditCtrl = edit ? require(`redevelopment/system/reportTemplateSetting/${edit.controllerName}`) : require('./reportTemplateEditCtrl')
const reportTemplatePreviewCtrl = preview ? require(`redevelopment/system/reportTemplateSetting/${preview.controllerName}`) : require('./reportTemplatePreviewCtrl')



export default angular
    .module('system.settingcenter.reportTemplateSetting', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('reportTemplateSettingCtrl', reportTemplateSettingCtrl.default)
    .controller('reportTemplateAddCtrl', reportTemplateAddCtrl.default)
    .controller('reportTemplateEditCtrl', reportTemplateEditCtrl.default)
    .controller('reportTemplatePreviewCtrl', reportTemplatePreviewCtrl.default)
    .filter('publishState', () => (state) => {
        state = Number(state)
        switch (state) {
        case 1:
            return '已发布'
        case 0:
            return '未发布'
        default:
            return ''
        }
    })
    .filter('templateType', () => (type) => {
        type = Number(type)
        switch (type) {
        case 1:
            return '内置报表模板'
        case 2:
            return '自定义报表'
        default:
            return ''
        }
    })
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/reportTemplateSetting/index.js